module.exports = __webpack_public_path__ + "static/media/close.5288d6ec.svg";